import { POST } from '@/api'
import { keyBy } from 'lodash'
import { renameKeysToSnakeCase } from '@/utils/renameKeys'
import detail from './detail'

/**
 * 予約受付枠設定
 */
export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
  },
  mutations: {
    set(state, syncGnavis) {
      state.byId = keyBy(syncGnavis, 'id')
      state.allIds = syncGnavis.map(syncGnavi => syncGnavi.id)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  modules: {
    detail,
  },
  getters: {
    all(state) {
      return state.allIds.map(id => state.byId[id])
    },
  },
  actions: {
    async get(store, { readonly = false } = {}) {
      const { commit, rootState } = store
      commit('busy', true)

      const currentStore = rootState.stores.current.store
      const { status, message, data } = await POST('/api/web/sync_gnavi/list', { storeId: currentStore.id, readonly })
      if (status === 200) {
        commit('set', data.syncGnaviList)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async remove(store, id) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/sync_gnavi/delete', { id })
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async saveOrder(store, syncGnaviIds) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/sync_gnavi/order', renameKeysToSnakeCase({ syncGnaviIds }))
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
